import styled, { keyframes, css } from 'styled-components'
import { Box } from 'rebass'
import { maxWidth, borders, borderRadius, height } from 'styled-system'

const fadeIn = props => {
  let keyframe = null
  switch (props.animationType) {
    case 'up':
      return (keyframe = keyframes`
        from {
            opacity: 0;
            transform: translate3d(0, -40%, 0);
          }
        
          to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
          }`)
    case 'bottom':
    default:
      return (keyframe = keyframes`
        from {
            opacity: 0;
            transform: translate3d(0, 40%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }  
    `)
  }
  return keyframe
}

const animation = ({ type = 'Bottom' }) =>
  css`
    ${fadeIn} .3s;
  `

const TooltipBox = styled(Box)`
    margin-left: 4px;
    box-shadow: ${props => props.theme.shadows[5]};
    border-radius: 4px;
    animation: ${animation};
    ${maxWidth} ${borders} ${borderRadius} ${height};

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        text-align: left;

        li {
            font-weight: normal;
            cursor: pointer;
            padding: 9px;
            color: #918d8d;
            transition: all .1s;
            &:hover {
                background-color: #f7f7f7;
                color: #3d3b3b;
            }
        }
    }
`

TooltipBox.defaultProps = {
  maxWidth: 'xlarge',
  bg: 'white.default',
  color: 'black',
  border: '1px solid #e9eaeb',
  mx: 'auto',
  l: '10px',
  ml: '10px',
  p: 3
}

export default TooltipBox
